import { Divider, DividerProps } from "semantic-ui-react";

type BPDividerProps = DividerProps & {};

export function BPDivider(props: BPDividerProps) {
    return <Divider {...props}>{props.children}</Divider>;
}